import { RemoveSymbolsByMaskActionHandler } from "@slot/client-engine";
import type { BaseGridPresenter, GridPresenter, MechanicPlugin } from "@slot/mechanics-core";

/**
 * Plain reels as a mechanic plugin: the frame presenter prepares through the reel adapter and reveals
 * through the composite grid presenter (the reel layer spins / stops; the win layers draw the win
 * from the same event). Reels have no removal step: the mask handler delegates to the composite,
 * whose reel layers no-op, so the contract is honoured without special-casing. The reels brake
 * their own drum under a private scope (`ReelSpinMechanic.requestSlamStop`), so no slam scope.
 */
export function buildReelsReplayPlugin(input: { gridPresenter: GridPresenter; basePresenter: BaseGridPresenter }): MechanicPlugin {
  const { gridPresenter, basePresenter } = input;
  return {
    framePresenter: {
      prepareEventFrame: (event) => basePresenter.prepareEventFrame(event),
      revealEventFrame: (event) => gridPresenter.presentEventFrame(event),
    },
    plugin: {
      name: "reels",
      actionHandlers: [new RemoveSymbolsByMaskActionHandler((positionMask) => gridPresenter.removeSymbolsByMask(positionMask))],
    },
    slamScopes: { presentation: [] },
  };
}
